// Agent mock data for GetAgents query
export const agentsMockData = {
  items: [
    {
      id: "agent-1",
      name: "Customer Support Bot",
      description: "Handles basic customer inquiries and troubleshooting",
      status: "ACTIVE",
      channel: "KIOSK",
      lastActive: new Date(Date.now() - 1200000).toISOString(),
      metrics: {
        conversations: 1248,
        avgRating: 4.7,
        successRate: 92.3
      }
    },
    {
      id: "agent-2",
      name: "Product Recommendation Agent",
      description: "Suggests personalized products based on customer preferences",
      status: "ACTIVE",
      channel: "KIOSK",
      lastActive: new Date(Date.now() - 3600000).toISOString(),
      metrics: {
        conversations: 953,
        avgRating: 4.5,
        successRate: 88.7
      }
    },
    {
      id: "agent-3",
      name: "Return Processing Assistant",
      description: "Guides customers through return and exchange procedures",
      status: "ACTIVE",
      channel: "KIOSK",
      lastActive: new Date(Date.now() - 7200000).toISOString(),
      metrics: {
        conversations: 721,
        avgRating: 4.2,
        successRate: 91.5
      }
    },
    {
      id: "agent-4",
      name: "Inventory Checker",
      description: "Helps customers check product availability across locations",
      status: "ACTIVE",
      channel: "KIOSK",
      lastActive: new Date(Date.now() - 10800000).toISOString(),
      metrics: {
        conversations: 1082,
        avgRating: 4.8,
        successRate: 97.2
      }
    },
    {
      id: "agent-5",
      name: "Order Status Tracker",
      description: "Provides real-time updates on customer orders",
      status: "ACTIVE",
      channel: "KIOSK",
      lastActive: new Date(Date.now() - 14400000).toISOString(),
      metrics: {
        conversations: 1567,
        avgRating: 4.6,
        successRate: 94.8
      }
    },
    {
      id: "agent-6",
      name: "Assembly Helper",
      description: "Assists customers with product assembly instructions",
      status: "ACTIVE",
      channel: "KIOSK",
      lastActive: new Date(Date.now() - 21600000).toISOString(),
      metrics: {
        conversations: 642,
        avgRating: 4.3,
        successRate: 86.9
      }
    },
    {
      id: "agent-7",
      name: "Sustainability Advisor",
      description: "Educates customers about sustainable products and practices",
      status: "ACTIVE",
      channel: "KIOSK",
      lastActive: new Date(Date.now() - 28800000).toISOString(),
      metrics: {
        conversations: 498,
        avgRating: 4.4,
        successRate: 89.5
      }
    },
    {
      id: "agent-8",
      name: "Delivery Scheduler",
      description: "Helps customers schedule and manage deliveries",
      status: "ACTIVE",
      channel: "KIOSK",
      lastActive: new Date(Date.now() - 36000000).toISOString(),
      metrics: {
        conversations: 873,
        avgRating: 4.1,
        successRate: 92.7
      }
    }
  ],
  totalCount: 8,
  pageInfo: {
    hasNextPage: false,
    hasPreviousPage: false
  }
};